import { customAlphabet } from "nanoid";
import axios from "axios";
import Service from "lib/models/Service";

const BASE_URL = "https://prod.lawfully-api.com";
const nanoid = customAlphabet("abcdefghijklmnopqrstuvwxyz", 10);

export default class CommunityService extends Service {
  /**
   * Retrieves comments.
   */
  async getListComment(
    postId: number,
    page: number,
    size: number,
  ): Promise<ResListComment> {
    const { data } = await axios.get(
      `${BASE_URL}/mobile/v1/community/public-posts/${postId}/comments`,
      {
        params: {
          page_number: page,
          page_size: size,
        },
      },
    );
    return data;
  }

  /**
   * Retrieves a post.
   */
  async getPost(postId: number): Promise<ResPost> {
    const { data } = await axios.get(
      `${BASE_URL}/mobile/v1/community/public-posts/${postId}`,
    );
    return data;
  }

  /**
   * Retrieves posts.
   */
  async getListPost({ page }: { page: number }) {
    const { data } = await axios.get(
      `${BASE_URL}/mobile/v1/community/public-posts`,
      {
        params: {
          page_number: page,
          page_size: 10,
        },
      },
    );
    return data;
  }

  /**
   * Signs Tracker-client in.
   */
  async signInClient(
    email: string,
    password = "lawfully4you",
  ): Promise<ResClient> {
    const res = await this.post(`${BASE_URL}/web/tracker/v1/login`, {
      email,
      password,
      version: "",
    });
    return res;
  }

  /**
   * Retrieves dummy clients.
   */
  async getListDummyClient(): Promise<ResCommunityProfile[]> {
    const res = await this.get("/community/accounts");
    return res;
  }

  /**
   * Creates a post as a new user.
   */
  async writePostAsNewUser(data: ReqPostNewUser) {
    const res = await this.post("/community/post-with-new", data);
    return res;
  }

  /**
   * Creates a post as an existing user.
   */
  async writePostAsExistingUser(data: {
    userId: number;
    title: string;
    contents: string;
  }) {
    const res = await this.post("/community/post", {
      userId: data.userId,
      title: data.title,
      contents: data.contents,
    });
    return res;
  }

  /**
   * Creates a dummy client and sets up community profile.
   */
  async createDummyClient(data: {
    firstName: string;
    lastName: string;
    profileImage?: string;
  }): Promise<ResClient> {
    // Create a dummy account.
    const email = `dummy_${nanoid()}@lawfully.com`;
    const password = "lawfully4you";
    await axios.post(`${BASE_URL}/web/tracker/v1/users`, {
      email,
      password,
    });
    // Sign in to get an auth-token.
    const client = await this.signInClient(email, password);
    // Create community profile.
    await axios.post(
      `${BASE_URL}/mobile/v1/community/profile`,
      {
        firstName: data.firstName,
        lastName: data.lastName,
        profileImage: data.profileImage,
      },
      {
        headers: {
          Authorization: client.token,
        },
      },
    );
    return client;
  }

  /**
   * Given a client's auth-token, creates a new comment.
   */
  async createComment(token: string, postId: number, comment: string) {
    const res = await axios.post(
      `${BASE_URL}/mobile/v1/community/posts/${postId}/comments`,
      { comment },
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return res.data;
  }
}
